<template>
  <div class="home">
    <h1>API Credential</h1>
    <snackbar :text="text" v-if="text"/>

    <v-container style="max-width: 85%">
      <v-card class="pa-5">
        <v-layout wrap fill-height class="text-xs-left">
          <v-flex xs12 class="mb-3">
            <v-layout wrap>
              <v-flex xs12 sm12 md6 lg4 xl3 class="font-weight-bold">App ID</v-flex>
              <v-flex xs12 sm12 md6 lg4 xl3>{{ this.$store.getters.getAppId }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="mb-3">
            <v-layout wrap>
              <v-flex xs12 sm12 md6 lg4 xl3 class="font-weight-bold">App Key</v-flex>
              <v-flex xs12 sm12 md6 lg4 xl3>{{ this.$store.getters.getAppKey }}</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap fill-height class="text-xs-left">
          <v-flex xs12 class="mb-3">
           <v-layout wrap>
              <v-flex xs12 sm12 md6 lg4 xl3 class="font-weight-bold">API Documentation</v-flex>
              <v-flex xs12 sm3 md1 lg0>
                <a :href="$store.getters.getApiDoc" target="_blank" rel="noopener noreferrer">
                  Download Doc
                </a>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue'
import { mapState } from 'vuex'

export default {
  name: 'Api',
  components: {
    Snackbar
  },
  data: () => ({
    text: null
  }),
  computed: {
    ...mapState([
      'accessApi'
    ])
  },
  mounted () {
    if (this.accessApi !== 'Yes') {
      this.$router.push('/')
    }
  },
  watch: {
    text () {
      setTimeout(() => {
        this.text = null
      }, 5000)
    }
  }
}
</script>
